import { useCallback, useState } from 'react';
import { useOnResize } from './use-on-resize.js';

const useIsMobile = () => {
  const getIsMobile = useCallback(() => (window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth) < 600, []);
  const [isMobile, setIsMobile] = useState(getIsMobile());
  useOnResize(() => setIsMobile(getIsMobile()), []);
  return isMobile;
};

export { useIsMobile };
//# sourceMappingURL=use-is-mobile.js.map
